import { useState } from "react";
import { FeedbackCard } from "../FeedbackCard";
import { FeedbackDetailModal } from "../FeedbackDetailModal";
import { Box, CircularProgress, Typography } from "@mui/material";

export const FeedbackList = ({
  userFeedbacks,
  page,
  cardsPerPage,
  isLoading,
  currentSection,
}) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setModalOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          pr: 2,
        }}
      >
        {userFeedbacks.length === 0 ? (
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              justifySelf: "center",
              height: "90%",
            }}
          >
            {isLoading ? (
              <CircularProgress
                sx={{
                  alignSelf: "center",
                }}
                variant="indeterminate"
              />
            ) : (
              <Typography
                variant="h5"
                style={{
                  alignSelf: "center",
                  fontFamily: "JetBrains Mono, sans-serif",
                  color: "#014F6D",
                }}
              >
                Nenhum feedback encontrado.
              </Typography>
            )}
          </div>
        ) : (
          userFeedbacks
            .slice((page - 1) * cardsPerPage, page * cardsPerPage)
            .map((card) => (
              <div key={card.id_feedback} onClick={() => handleCardClick(card)}>
                <FeedbackCard card={card} currentSection={currentSection} />
              </div>
            ))
        )}
      </Box>

      <FeedbackDetailModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        card={selectedCard}
      />
    </>
  );
};
